<template>
    <div :id="id" class="tabs__content" :class="{'tabs__content--visible': isTabEnabled }" style="background-color:#607466">
         <slot />
    </div>
</template>
<script>
  import tabMixin from '../../../utils/tabMixin'

  export default {
    name: 'nt-tab-item',
    mixins: [tabMixin],
    props: {
      id: String
    },
    computed: {
      isTabEnabled() {
        return this.selectedTab === this.id
      }
    }
  }
</script>